export default __webpack_public_path__ + "static/media/xMARK.348d6a25.png";